<template>
    <div class="principal">
        <div class="body" style="flex-direction: column; margin-top: -70px;">
            <div v-if="tperror === '402'" style="display: flex; align-items: center; height: 100vh; flex-direction: column; color: white; text-align: center; font-family: 'Roboto', sans-serif;">
                <!-- mensagem para dispositivos -->
                <h1 class="mt-4" style="font-size: 48px; font-weight: bold; margin-bottom: 10px;">Ops, seu dispositivo está com o acesso bloqueado!</h1>
                <p style="font-size: 20px; max-width: 600px; line-height: 1.5;">
                    No momento você não tem permissão para acessar o sistema. Solicite o desbloqueio com seu supervisor.
                </p>
                <div class=" detalhes card_dispositivo mt-4" v-if="tperror === '402'" style="display: flex; border-radius: .375rem; border: 1px solid #fff; padding: 2.5rem; align-items: start; flex-direction: column; width: 400px;">
                    <h5>Detalhes do dispositivo</h5> 
                    <p><i class="fa fa-user"></i> Usuário: <span>{{ usuario }}</span></p>
                    <p><i class="fa fa-desktop"></i> Id. dispositivo: <span>{{ iddispositivo }}</span></p>
                <hr>
                    <p><i class="fa fa-ban"></i> Status Code: <span>{{ tperror }}</span></p>
                    <p><i class="fa fa-globe"></i> Navegador: <span>{{ navegador }}</span></p>
                </div>
                <button class="btn btn-primary" style="margin-top: 20px;   padding: 12px 25px;   font-size: 18px;   color: #fff;  text-decoration: none;   border-radius: 8px;   border: 2px solid transparent; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  cursor: pointer;" 
                @click.prevent="logout()">
                    Sair <i class="fa fa-sign-out"></i>
                </button>      
            </div>
            <div v-if="tperror === '403'" style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; color: white; text-align: center; font-family: 'Roboto', sans-serif;">
                <!-- mensagem para horarios -->
                <h1  style="font-size: 48px; font-weight: bold; margin-bottom: 10px;">Ops, seu horário de acesso encerrou!</h1>
                <p style="font-size: 20px; max-width: 600px; line-height: 1.5;">
                    No momento você não tem permissão para acessar o sistema. Você está fora do seu horário permitido.
                </p>
                <button class="btn btn-primary" style="margin-top: 20px;   padding: 12px 25px;   font-size: 18px;   color: #fff;  text-decoration: none;   border-radius: 8px;   border: 2px solid transparent; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  cursor: pointer;" 
                @click.prevent="logout()">
                    Sair <i class="fa fa-sign-out"></i>
                </button>      
            </div>
        </div>
    </div>
</template>
<script>
import util from '../utilitarios/util';

export default{
    data: function() {
        return {
            tperror: "",
            usuario: "",
            iddispositivo: "",
            navegador: "",
        }
    },
    methods:{
        logout(){
            util.logoff();
        },
    },
    mounted: function () {
        this.tperror = localStorage.getItem('tipoerror');
        this.usuario = localStorage.getItem('nome');
        this.iddispositivo = localStorage.getItem('evahc');
        this.navegador = localStorage.getItem('navg');
    }
}
</script>
<style>
.principal{
    height: 100dvh;
    width: 100% !important;
    background-color: #1e2b37 ;
    margin-top: 0;
}
.body{
    height: 100dvh;
    width: 100% !important;
    background-color: #1e2b37 ;
}
/*#dvconteudoapp{
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}*/
hr {
    border: none;
    border-top: 1px solid #fff;
    width: 100%;
    background-color: #fff;
}


</style>